// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import bellIcon from '../../../images/common/bellIcon.png'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const RemarksIcon = ({ VisitId, onClick }) => (
  <img
    role='presentation'
    src={bellIcon}
    data-id={VisitId}
    className='remarks-bell-icon'
    onClick={onClick}
    alt='bellIcon'
  />
)
